/**
 * Подразделение «Не указано» (training-listeners-count; ТЗ 26.10.2026, п.1.3): в него попадает
 * сотрудник, добавленный в заявку на обучение только с ФИО и должностью. Зеркало
 * `domain.UnspecifiedDepartment`. Для СОУТ и профрисков подразделение остаётся обязательным —
 * «Не указано» там считается незаполненным.
 */
export const UNSPECIFIED_DEPARTMENT = 'Не указано'

/** Подразделение не указано: пусто или «Не указано». */
export function isUnspecifiedDepartment(name: string): boolean {
  const value = name.trim()
  return value === '' || value.toLowerCase() === UNSPECIFIED_DEPARTMENT.toLowerCase()
}
